const TabStyles = () => ({
  table: {
    overflow: 'auto',
    maxHeight: 'calc(100vh - 364px)',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  },
  paperContainer: {
    width: '100%'
  },
  checkboxCell: {
    width: '24px',
    borderLeft: '0',
    borderRight: '1px solid rgba(224, 224, 224, 1)'
  },
  cell: {
    borderLeft: '0',
    '&:last-child': {
      borderRight: '0'
    }
  },
  gridItem: {
    flexBasis: 'auto !important',
    marginRight: '16px'
  },
  buttonFooter: {
    flex: 1,
    marginTop: '15px'
  },
  informationText: {
    fontSize: '14px',
    color: '#757575'
  },
  selectInputContainer: {
    width: 'auto'
  },
  selectInputText: {
    fontSize: '14px',
    display: 'flex',
    color: '#757575',
    alignItems: 'center'
  },
  informationNumber: {
    color: '#212121',
    marginLeft: '3px'
  },
  progress: {
    display: 'flex',
    justifyContent: 'center'
  },
  emptyLabel: {
    color: '#424242',
    fontSize: '14px',
    display: 'inline-block'
  },
  tableContainer: {
    borderTop: '0px'
  },

  buttonDisabled: {
    backgroundColor: '#F5F5F5',
    color: '#757575 !important'
  },
  footerButton: {
    marginRight: '10px'
  },
  downloadDoc: {
    color: 'blue',
    cursor: 'pointer'
  },
  loading: {
    height: '40vh'
  },
  tooltipPlacementTop: {
    marginLeft: '30px'
  },
  informationsContainer: {
    display: 'flex',
    width: 'inherit'
  },
  nonFilter: {
    height: '48px'
  }
});

export default TabStyles;
